import { useTranslation } from 'react-i18next'

import { CompactAlert } from '~/components/common/CompactAlert'

type Props = {
  /** 表示中の受渡日の、 発注主体区分が空欄の札の受渡契約コード (重複なし)。 */
  deliveryContractCodes: readonly string[]
}

/**
 * 広域マスタに無い受渡契約コードの札を取り込んだ時の警告 (AC-BSP-111b / AC-BIN-109a、
 * #10084)。 コードが無ければ何も描画しない。
 */
export const UnknownIssuerBidBanner = ({
  deliveryContractCodes,
}: Props): React.ReactElement | null => {
  const { t } = useTranslation()
  if (deliveryContractCodes.length === 0) return null
  const prefix = 'common:bidding.unknownIssuerBid'

  return (
    <CompactAlert
      description={t(`${prefix}.body`)}
      status="warning"
      title={t(`${prefix}.title`, {
        codes: deliveryContractCodes.join(t(`${prefix}.codeSeparator`)),
      })}
    />
  )
}
